module.exports = __webpack_public_path__ + "static/media/wire1.32f67a5d.jpeg";